import React from "react";
import "../../devices/components/DeleteDevice.css";

// The dialog's words, by kind, in one place (FE-84 renames them here).
const DELETE_USER_COPY = Object.freeze({
  customer: Object.freeze({
    title: "Delete customer",
    fallbackName: "this customer",
    warning: "This can't be undone. The customer and their sign-in are removed.",
  }),
  employee: Object.freeze({
    title: "Delete employee",
    fallbackName: "this employee",
    warning: "This can't be undone. The employee and their sign-in are removed.",
  }),
});

// Confirms a Customer or employee delete. Presentational: it names the
// person (first and last name, never the email) and leaves the request to
// the page's useDeleteUser.
export default function DeleteUserModal({ open, user, kind, onConfirm, onClose, loading = false }) {
  if (!open || !user) return null;

  const copy = DELETE_USER_COPY[kind] || DELETE_USER_COPY.employee;
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ").trim() || copy.fallbackName;

  return (
    <>
      <div className="delete-device-overlay" onClick={loading ? undefined : onClose} />
      <div
        className="delete-device-popup-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-user-title"
      >
        <div className="delete-device-header-container">
          <h3 className="delete-device-title" id="delete-user-title">
            {copy.title} &ldquo;{name}&rdquo;?
          </h3>
          <button
            type="button"
            className="delete-device-close-button"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="delete-device-content-container">
          <p className="delete-device-warning">{copy.warning}</p>
        </div>
        <div className="delete-device-form-actions">
          <button
            type="button"
            className="delete-device-cancel-action"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-device-delete-button"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-small" /> Deleting&hellip;
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </>
  );
}
